(() => {
  'use strict';
  const key = 'neb-favorites-v1';
  let memory = new Set();
  let storageAvailable = true;
  const read = () => {
    if (!storageAvailable) return new Set(memory);
    try {
      const stored = JSON.parse(localStorage.getItem(key) || '[]');
      if (Array.isArray(stored)) memory = new Set(stored.filter(value => typeof value === 'string'));
    } catch (_) { storageAvailable = false; }
    return new Set(memory);
  };
  const paint = () => {
    const saved = read();
    document.querySelectorAll('[data-neb-favorite]').forEach(button => {
      const active = saved.has(button.dataset.productId);
      button.disabled = false;
      button.setAttribute('aria-pressed',String(active));
      button.title = active ? button.dataset.removeLabel : button.dataset.saveLabel;
    });
  };
  document.addEventListener('click',event => {
    const button = event.target.closest('[data-neb-favorite]');
    if (!button) return;
    const saved = read();
    const id = button.dataset.productId;
    if (!id) return;
    const active = !saved.has(id);
    if (active) saved.add(id);else saved.delete(id);
    memory = saved;
    let persistent = true;
    try { localStorage.setItem(key,JSON.stringify([...saved])); }
    catch (_) { persistent = false;storageAvailable = false; }
    document.querySelectorAll('[data-neb-favorite]').forEach(control => {
      const selected = saved.has(control.dataset.productId);
      control.setAttribute('aria-pressed',String(selected));
      control.title = selected ? control.dataset.removeLabel : control.dataset.saveLabel;
    });
    const status = button.closest('[data-ct-product]')?.querySelector('[data-neb-favorite-status]');
    if (status) status.textContent = active ? (persistent ? button.dataset.savedMessage : button.dataset.sessionMessage) : button.dataset.removedMessage;
  });
  window.addEventListener('storage',event => { if (event.key === key || event.key === null) { memory = new Set();storageAvailable = true;paint(); } });
  document.addEventListener('ct:variant-changed',paint);
  document.addEventListener('shopify:section:load',paint);
  paint();
})();
